export default __webpack_public_path__ + "static/media/courseIcon.e02646e9.svg";